<template>
  <div class="contain">
    <div class="in-content">
      <el-row class="containRow" :gutter="20">
        <el-col :span="20">
          <div class="grid-content bg-purple Info">
            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">家族史</h2>
                <div class="circle">
                  <el-button type="primary" @click="addOneRow('familyHistory')" icon="el-icon-edit" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('familyHistory')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.familyHistory">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'familyHistory')"
                  v-model="all_sides.familyHistory[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">过往病史及过敏史</h2>
                <div class="circle">
                  <el-button type="primary" @click="addOneRow('allergicHistory')" icon="el-icon-edit" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('allergicHistory')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.allergicHistory">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'allergicHistory')"
                  v-model="all_sides.allergicHistory[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree" v-show="sex == '女'">
              <div class="in-past">
                <h2 style="line-height:40px;">月经史，绝经期，孕产史</h2>
                <div class="circle">
                  <el-button type="primary" @click="addOneRow('menstruation')" icon="el-icon-edit" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('menstruation')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.menstruation">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'menstruation')"
                  v-model="all_sides.menstruation[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">生活偏嗜</h2>
                <div class="circle">
                  <el-button type="primary" @click="addOneRow('liveData')" icon="el-icon-edit" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('liveData')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
                <div class="in-disease" :key="index" v-for="(item,index) in all_sides.liveData">
                <el-input
                  type="textarea"
                  :value="item"
                  style="padding-top: 10px"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'liveData')"
                  v-model="all_sides.liveData[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">病因病机</h2>
                <div class="circle">
                  <el-button type="primary" @click="addOneRow('pathogenyAndPathology')" icon="el-icon-edit" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('pathogenyAndPathology')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.pathogenyAndPathology">
                <el-input
                  type="textarea"
                  :value="item"
                  style="padding-top: 10px"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'pathogenyAndPathology')"
                  v-model="all_sides.pathogenyAndPathology[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree" v-if="false">
              <div class="in-past">
                <h2 style="line-height:40px;">侧边信息字段A</h2>
                <div class="circle">
                  <el-button type="primary" @click="addOneRow('sideInformationA')" icon="el-icon-edit" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('sideInformationA')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.sideInformationA">
                <el-input
                        type="textarea"
                        style="padding-top: 10px"
                        :value="item"
                        autosize
                        placeholder="请输入内容"
                        @change="changeOneRow($event,index,'sideInformationA')"
                        v-model="all_sides.sideInformationA[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">病毒携带史</h2>
                <div class="circle">
                  <!--新增-->
                  <el-button
                    type="primary"
                    @click="edit(dialogTableVisible = true)"
                    icon="el-icon-edit"
                    circle
                  ></el-button>
                  <!--详情-->
                  <el-button type="warning" icon="el-icon-document" circle></el-button>
                </div>
              </div>

              <div style="margin-top: 10px">
                <el-table :data="gridData" style="width: 450px" border>
                  <el-table-column type="index" width="50" label="序号"></el-table-column>
                  <el-table-column property="virus" label="病毒类型"></el-table-column>
                  <el-table-column property="year" label="持续时间"></el-table-column>
                  <el-table-column property="approach" label="感染途径"></el-table-column>
                  <el-table-column label="操作">
                    <template scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <br>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row,gridData)"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <el-dialog width="35%" :visible.sync="dialogFormVisible" append-to-body>
              <el-form>
                <el-form-item style="text-align:left;" label="病毒携带史:" :label-width="formLabelWidth">
                  <el-select v-model="virus" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in virusCarry"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="text-align:left;"
                  label="持续时间 - 年:"
                  :label-width="formLabelWidth"
                >
                  <template>
                    <el-input-number v-model="year" :precision="1" :step="0.1" :min="0.1"></el-input-number>
                  </template>
                </el-form-item>
                <el-form-item label="感染途径:" :label-width="formLabelWidth">
                  <el-autocomplete
                    style="width:100%;"
                    v-model="approach"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave(dialogFormVisible = false)">确 定</el-button>
              </div>
            </el-dialog>

            <!--//小图标新增-->
            <el-dialog title="新增病毒携带史" :visible.sync="dialogTableVisible">
              <el-form>
                <el-form-item style="text-align:left;" label="病毒携带史:" :label-width="formLabelWidth">
                  <el-select v-model="virus" placeholder="请选择" filterable>
                    <el-option
                      v-for="(item,index) in virusCarry"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="text-align:left;"
                  label="持续时间 - 年:"
                  :label-width="formLabelWidth"
                >
                  <template>
                    <el-input-number v-model="year" :precision="1" :step="0.1" :min="0.1"></el-input-number>
                  </template>
                </el-form-item>
                <el-form-item label="感染途径:" :label-width="formLabelWidth">
                  <el-autocomplete
                    style="width:100%;"
                    v-model="approach"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="addbingdu(dialogTableVisible = false)">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button type="primary" @click="saveUserHistory" v-show="rId">立即修改</el-button>
    <el-button @click="addCreateInfo" v-show="!rId">添加到创建列表</el-button>
  </div>
</template>

<script>
export default {
  props: ["cmsg", "sex", "rId"],
  data() {
    return {
      virusCarry: [
        //  病毒携带史
        {
          value: "乙肝",
          label: "乙肝"
        },
        {
          value: "丙肝",
          label: "丙肝"
        },
        {
          value: "HP",
          label: "HP"
        },
        {
          value: "HPV",
          label: "HPV"
        },
        {
          value: "梅毒",
          label: "梅毒"
        }
      ],
      gridData: [],
      routerid: "",
      virus: "",
      restaurants: [
        { value: "纹眉", address: "纹眉" },
        { value: "纹唇", address: "纹唇" },
        { value: "耳洞", address: "耳洞" },
        { value: "洗牙", address: "洗牙" },
        { value: "游泳", address: "游泳" },
        { value: "温泉", address: "温泉" },
        { value: "公共浴池", address: "公共浴池" },
        { value: "其他", address: "其他" }
      ],
      approach: "",
      reservationId: 0,
      year: 0,
      form: {
        virus: "",
        year: "",
        approach: ""
      },
      dialogFormVisible: false, //  新增 病毒携带史
      dialogTableVisible: false, //  form 编辑
      innerVisible: false, //  内层
      formLabelWidth: "130px",
      activeNames: [], //  手风琴参数

      formData: [
        { text: "现病史:" },
        { text: "既往辅助检查:" },
        { text: "刻下:" },
        { text: "舌苔:" },
        { text: "脉象:" }
      ],
      _data: {
        //  新增行数据
        disname: ""
      },
      all_sides: {
        allergicHistory: [], // diseaseData
        familyHistory: [], // famliyData
        liveData: [], // lifePartialAddicted
        menstruation: [],  // menstrual
        pathogenyAndPathology: [],
        sideInformationA: [],
      },
      index: "",
    };
  },
  mounted: function() {
    this.routerid = this.cmsg.routerid;
    this.all_sides.familyHistory = this.cmsg.familyHistory;
    this.all_sides.menstruation = this.cmsg.menstrual;
    this.all_sides.allergicHistory = this.cmsg.allergicHistory;
    this.all_sides.liveData = this.cmsg.lifePartialAddicted;
    this.all_sides.pathogenyAndPathology = this.cmsg.pathogenyAndPathology;
    this.all_sides.sideInformationA = this.cmsg.sideInformationA;
    let a = this.cmsg.virusCarryingHistory;
    if (this.routerid) {
      let OBJ = {};
      for (let k = 0; k < a.length; k++) {
        let obj = [];
        obj = a[k].split(":");

        OBJ = {
          virus: obj[0],
          year: obj[1],
          approach: obj[2]
        };
        this.gridData.push(OBJ);
      }
    }
  },
  methods: {
    addbingdu: function() {
      if (this.virus == "") {
        this.$alert("请选择病毒携带史");
        return false;
      }
      if (this.approach == "") {
        this.$alert("请选择感染途径");
        return false;
      }
      let virusCarryingHistory = {
        //病毒携带史
        virus: this.virus, //病毒种类
        year: this.year, //病毒时间
        approach: this.approach //感染途径
      };
      this.gridData.push(virusCarryingHistory);
      console.log(this.gridData);
    },
    //小图标编辑
    edit: function() {
      this.virus = "";
      this.year = "";
      this.approach = "";
    },
    //编辑
    handleEdit(index, row) {
      console.log(index);
      this.index = index;
      this.dialogFormVisible = true;
      let virus = row.virus;
      let year = row.year;
      let approach = row.approach;
      this.virus = virus;
      this.year = year;
      this.approach = approach;
    },
    //删除
    handleDelete: function(index, row, rows) {
      rows.splice(index, 1);
    },
    //编辑完保存
    handleSave() {
      let a = {
        virus: this.virus,
        year: this.year,
        approach: this.approach
      };
      this.gridData.splice(this.index, 1, a);
      console.log(this.gridData);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
    },
    inquiryLi() {
      //  切换就诊人
      this.$router.push({
        path: "/home/inquiryList"
      });
    },

    // 封装公共方法
    make_all_sides_data(all_sides, grid_data) {
      let all_data = JSON.parse(JSON.stringify(all_sides));  // 深拷贝
      let virus = ""; // 病毒携带
      for (let obj in all_data) {
        if (all_data[obj].length==0) {
          all_data[obj] = "";
        } else {
          for (let i = 0; i < obj.length; i++) {
            if (typeof obj[i] != "string") {
              all_data[obj][i] = "";
            }
          }
          all_data[obj] = all_data[obj].join("%");
        }
      }
      // 处理病毒携带字段
      for (let k = 0; k < grid_data.length; k++) {
        let b =
                grid_data[k].virus +
                ":" +
                grid_data[k].year +
                ":" +
                grid_data[k].approach;
        virus += b + ";";
      }
      virus = virus.substr(0, virus.length - 1);
      all_data.virus = virus
      return all_data;
    },
    addCreateInfo() {
      let all_data = this.$options.methods.make_all_sides_data(this.all_sides, this.gridData);
      console.log(JSON.stringify(all_data));
      this.$emit("objList", all_data);
    },

    saveUserHistory() {  // 立即保存侧边病史
      let all_data = this.$options.methods.make_all_sides_data(this.all_sides, this.gridData);
      this.$axios({
          url: '/api/user/userhistory/' + this.routerid,
          method: 'PUT',
          data: {
            allergicHistory: all_data.allergicHistory,
            familyHistory: all_data.familyHistory,
            lifePartialAddicted: all_data.liveData,
            virusCarryingHistory: all_data.virus,
            menstrual: all_data.menstruation,
            pathogenyAndPathology: all_data.pathogenyAndPathology,
            sideInformationA: all_data.sideInformationA,
          }
        }).then(res => {
          if (res.data.code == 200) {
              this.$message({
                  type: 'success',
                  message: '操作成功'
              })
              // this.$router.push({path: './patientlist'});
          }
          else {
              this.$message({
                  type: 'failed',
                  message: res.data.msg
              })
          }

        }).catch(err => {
            // console.log(err.data);
        })
            // console.log(this.form)
    },
    // 修改一行
    changeOneRow(val, index, side_msg) {
      this.all_sides[side_msg][index] = val;
    },
    // 新增空行
    addOneRow(side_msg) {
      this.all_sides[side_msg].push("");
    },
    // 删除一行
    deleteOneRow(side_msg) {
      this.all_sides[side_msg].pop();
    },
  }
};
</script>

<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
.doctorImg {
  display: inline-block;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.circle {
  float: right;
  margin-right: 15px;
}

.butn {
  text-align: center;
  width: 50px;
}

.in-past h2 {
  float: left;
  padding-right: 20px;
}

.contain {
  padding: 10px 15px;
  background: #ffffff;
}

.finishDoctor {
  display: inline-block;
  margin-left: 30px;
}

.contain .color {
  color: #20a0ff;
  cursor: pointer;
}

.contain a {
  color: blue;
  text-decoration: none;
}

.in-location h2 {
  font-weight: normal;
  font-size: 16px;
  color: #dcdcdc;
  padding: 10px 0 0 10px;
}

.containRow {
  margin: 0 !important;
}

.first-nav {
  line-height: 36px;
  height: 36px;
}

.in-btn button {
  padding: 10px 30px;
}

.in-content .Info {
  text-align: center;
  margin-top: 10px;
}

.in-con {
  box-shadow: 0 0 10px #dcdcdc;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  background: white;
  padding-top: 12px;
  margin-bottom: 30px;
}

.in-file {
  margin-top: 5px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dcdcdc;
}

.in-file a {
  margin-left: 25px;
}

.in-file i {
  margin-right: 5px;
}

.in-table,
.in-tel {
  height: 45px;
  text-align: left;
  border-bottom: 1px solid #dcdcdc;
}

.in-content h2 {
  font-weight: inherit;
  padding-left: 13px;
  color: #dcdcdc;
  margin: 0;
  font-size: 16px;
  display: inline-block;
}

.in-content h2 span {
  margin-left: 8px;
  color: black;
}

.in-table div {
  line-height: 45px;
  width: 48%;
  display: inline-block;
}

.in-tabOne {
  border-right: 1px solid #dcdcdc;
}

.in-tel h2 {
  line-height: 45px;
}

.in-remark {
  padding: 15px 0;
  text-align: left;
}

.in-remark h2 {
  width: 15%;
  display: inline-block;
}

.in-remark p {
  margin: 0;
  width: 70%;
  display: inline-block;
  white-space: pre-wrap;
}

.in-content .in-conTwo {
  padding-top: 0;
  text-align: left;
}

.in-header {
  height: 70px;
  line-height: 70px;
}

.in-header h2,
.in-text h2,
.in-past h2,
.in-disease p {
  margin-left: 8px;
  color: black;
  font-size: 20px;
}

.in-header span {
  display: inline-block;
  margin-right: 28px;
  cursor: pointer;
}

.in-header span i {
  margin-right: 10px;
}

.in-text {
  height: 60px;
  line-height: 60px;
  border-top: 1px solid #dcdcdc;
}

.in-text h2 {
  font-size: 18px;
  color: #787c7d;
  font-family: inherit;
}

.in-text h2 span {
  color: #dadcdb;
}

.in-text span {
  float: right;
  margin-right: 28px;
  color: blue;
  cursor: pointer;
}

.in-conThree {
  text-align: left;
  overflow: hidden;
  min-height: 53px;
}

.in-past {
  margin-bottom: 55px;
}

.in-date {
  margin: 8px 0 10px 21px;
}

.in-disease {
  padding-bottom: 12px;
  border-top: 1px solid #dcdcdc;
  font-size: 18px;
  margin: 0 auto;
  width: 89%;
}

.in-disease p {
  margin: 8px 15px 0 21px;
  display: block;
  white-space: pre-wrap;
}

.in-disDate {
  margin-left: 8px !important;
  color: #b6b6b6 !important;
}

.in-disBtn {
  margin: 8px 15px 0 21px;
}

.in-disBtn span {
  margin-right: 12px;
}

.in-disBtn span i {
  margin-right: 5px;
}

.in-disNone h2 {
  color: #b6b6b6;
  margin: 8px 15px 0 21px;
  font-size: 20px;
  display: block;
  padding: 0;
  height: 45px;
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// patientinquiry.vue?62f5b66a